import { trustBadges, socialProof } from '@/mocks/faq';

export default function TrustBadgesSection() {
  return (
    <section className="bg-background-50 py-8 md:py-10 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mb-6">
          {trustBadges.map((badge) => (
            <div key={badge.text} className="flex items-center gap-2 text-foreground-700">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${badge.icon} text-primary-500 text-base`}></i>
              </div>
              <span className="text-sm font-medium whitespace-nowrap">{badge.text}</span>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-14">
          {socialProof.map((item) => (
            <div key={item.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">{item.value}</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}